export const isTextContainsAnyWord = (text: string, words: string[]): boolean => {
    text = text.toLowerCase();
    const found_words: string[] = words.filter(word => {
        return text.includes(word);
    });
    return found_words.length > 0;
};
